import FinishGif from './win_gif.gif'

// field's names when answering mission
export const missionPEOField = (pe, peo) =>
  `page_element-${pe.id}-page_element_option-${peo.id}`
export const missionPEField = pe => `page_element-${pe.id}`
export const missionPLatField = pe => `lat_${pe.id}`
export const missionPLngField = pe => `lng_${pe.id}`
export const missionImageField = pe => `image_${pe.id}`
export const missionPhotoField = pe => `mission_page_${pe.id}`

// mission's states
export const MISSION_STATE_NOT_STARTED = 0
export const MISSION_STATE_STARTED = 1
export const MISSION_STATE_FINISHED = 2
export const MISSION_STATE_ACCEPTED = 3
export const MISSION_STATE_LOCKED = 4
export const MISSION_STATE_EXPIRED = 5
export const MISSION_STATE_REJECT = 6
export const MISSION_STATE_DAILY_EXPIRED = 7
export const MISSION_STATE_MAX_LIMIT = 8

// alerts when answering mission
export const ERROR_FORM_ANSWERS_WRONG = 'Las respuestas no son correctas.'
export const ERROR_FORM_ANSWERS_NEEDED = 'Debes responder todas las preguntas.'
export const ERROR_CHECKIN_NEEDED = 'Debes hace chekin para seguir.'
export const ERROR_PHOTO_NEEDED = 'Debes tomar una foto para seguir.'
export const ERROR_MENTION_NEEDED = 'Responde.'
export const warning_alert = {
  show: true,
  title: '¡Repasa las incorrectas!',
  type: 'warning',
  showConfirmButton: true,
  confirmButtonColor: '#F8BB86',
  imageUrl: null,
  time: false,
}
export const success_alert = {
  show: true,
  title: '¡Muy bien!',
  type: 'success',
  showConfirmButton: false,
  imageUrl: null,
  time: 1000,
}
export const off_alert = {
  show: false,
  title: '',
  type: null,
  showConfirmButton: false,
  imageUrl: null,
  time: false,
}
export const error_alert = message => ({
  show: true,
  title: message,
  type: 'error',
  showConfirmButton: false,
  imageUrl: null,
  time: 1000,
})
export const win_alert = ({ mission: { credits, experience } }) => ({
  show: true,
  title: '¡Misión Completada!',
  text: '',
  showConfirmButton: true,
  imageUrl: FinishGif,
  time: false,
})
export const win_alert_need_revision = {
  show: true,
  title: '¡Misión Completada!',
  text: `¡Muy bien hecho!\n
        Para resivir el premio por esta mision\n
        debes esperar a que un administrador la revise`,
  showConfirmButton: true,
  imageUrl: FinishGif,
  time: false,
  html: false,
}

// new events
export const boughtPrizeEvent = ({ image_url, name }) => ({
  show: true,
  title: '¡Excelente Compra!',
  text: `Para reclamar tu "${name}" debes esperar a que un administrador lo revise`,
  showConfirmButton: true,
  imageUrl: image_url,
  time: false,
  html: false,
})
export const newTitleEvent = ({ prefix_male }) => ({
  show: true,
  title: `!Ganaste un título!\n${prefix_male}`,
  text: 'Puedes cambiar tu título actual al editar tu perfil',
  showConfirmButton: true,
  imageUrl: 'https://pbs.twimg.com/profile_images/751467065043804160/EorjWBmQ.jpg',
  time: false,
  html: false,
})
export const newLvlEvent = lvl => ({
  show: true,
  title: `¡Subiste al nivel ${lvl}!`,
  text: '¡Sigue así y te convertiras en todo un heroe!',
  showConfirmButton: true,
  imageUrl: 'https://pbs.twimg.com/profile_images/751467065043804160/EorjWBmQ.jpg',
  time: false,
  html: false,
})
export const newMedalEvent = ({ name, description, image_url }) => ({
  show: true,
  title: `¡Ganaste una medalla!\n${name}`,
  text: description,
  showConfirmButton: true,
  imageUrl: image_url,
  time: false,
  html: false,
})



// WEBPACK FOOTER //
// ./src/utils/constants.jsx